import { render, staticRenderFns } from "./CreateNewPayout.vue?vue&type=template&id=4b5a3e90&scoped=true&"
import script from "./CreateNewPayout.vue?vue&type=script&lang=js&"
export * from "./CreateNewPayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a3e90",
  null
  
)

export default component.exports